import { Outlet } from "react-router";
import { LanguageFab } from "@/src/common/components/language-fab";

export function RootLayout() {
	return (
		<>
			<Outlet />
			<LanguageFab />
		</>
	);
}
